module.exports = __webpack_public_path__ + "r-v3/img/ml_20_00.e93aebe9.jpg";